export * from './ErrorBoundary';
import ErrorBoundary from './ErrorBoundary';
export default ErrorBoundary;
